// client/ui/ParentCoordinatorCoPilot.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class ParentCoordinatorCoPilot extends ComponentBase {
    constructor(config) {
        super(config);
        this.coPilotComponent = null;
    }

    async initialize() {
        await super.initialize();
    }

    async initAfterLogin() {
        const agentName = "ParentAssistantAgent";
        const queryParams = this.appClient.layoutEngine.getQueryParams();
        const impersonatedParentId = queryParams.impersonateParentId;
        const parentUserId = impersonatedParentId || this.appClient.getSharedData('userId');
        if (!parentUserId) {
            this.log.error("ParentCoordinatorCoPilot: Cannot initialize AiCoPilot without parent's userId.");
            return;
        }

        this.coPilotComponent = await this.createManagedComponent(
            'AdvancedAIWorkspace',
            null,
            {
                instanceId: `${this.config.instanceId || 'parentCoordinator'}-aicopilot`,
                agentName: agentName,
                singleAgentMode: true,
                height: 'container'
            }
        );
        if (this.container) {
            await this.render();
        }
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'parent-coordinator-copilot-container h-100 d-flex flex-column';
        }
        this.container.innerHTML = '';

        if (this.coPilotComponent) {
            this.container.appendChild(await this.coPilotComponent.render());
        } else {
            const loadingDiv = document.createElement('div');
            loadingDiv.className = 'p-3 text-center text-muted';
            loadingDiv.textContent = this.t('Loading Student Coordinator...');
            this.container.appendChild(loadingDiv);
        }
        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }

    destroy() {
        this.coPilotComponent?.destroy();
        this.coPilotComponent = null;
        super.destroy();
    }
}